import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import '../popUp/popUp.scss';
import './button.scss'

export const Button = ({ onClick, background, color, border, width, text, children, margin, borderRadius }) => {
    return (
        <button 
            type="button" 
            onClick={onClick} 
            style={{ background, color, border, width, margin, borderRadius }} 
            className="button"
        >
            { text ? text : children }
        </button> 
    )
}

export const AddButton = ({ onClick }) => {
    return (
        <Button onClick={onClick} >
            +
        </Button>
    );
};

export const LocationButton = ({ trigger, setTrigger }) => {
    const toggleVisibility = () => {
        setTrigger(prevState => !prevState);
    };

    return (
            <Button onClick={toggleVisibility}  border= '0px' background= 'none' margin= 'auto'>
                <LocationOnIcon style={{width: '60px', height: 'auto', position: 'relative', bottom: '20px'}} />
            </Button>
    );
};

export const CopyButton = ({ link, onClick }) =>{
    return(
        <Button onClick={onClick} border= '0px' background= 'none'>
            <CopyToClipboard text={ link }>
                <ContentCopyOutlinedIcon />
            </CopyToClipboard>
        </Button>
    ) 
}

export const PhoneButton = ({ link, onClick }) =>{
    return(
        <Button onClick={onClick} border= '0px' background= 'none'>
            <CopyToClipboard text={ link }>
                <img src='outline_phone_black_24dp.png' alt="cel" width={20} height={20} />
            </CopyToClipboard>
        </Button>
    ) 
}

export const PhoneMessageButton = ({ link, onClick }) =>{
    return(
        <Button onClick={onClick} border= '0px' background= 'none'>
            <CopyToClipboard text={ link }>
                <img src='outline_perm_phone_msg_black_24dp.png' alt="cel" width={20} height={20} />
            </CopyToClipboard>
        </Button>
    ) 
}

export const EditButton = ({ onClick }) => {
    return (
        <Button onClick={onClick}  border= '0px' background= 'none'>
            <ModeEditIcon />
        </Button>
    );
};

export const EyeButton = ({ onClick }) => {
    return (
        <Button onClick={onClick}  border= '0px' background= 'none'>
            <RemoveRedEyeIcon />
        </Button>
    );
};
export default Button

